const firebaseConfig = {
  apiKey: "AIzaSyBnXjC8j-LD4KLczjQ8JjGbTVBNlhqnAKg",
  authDomain: "brostrike-1cc8b.firebaseapp.com",
  projectId: "brostrike-1cc8b",
  storageBucket: "brostrike-1cc8b.firebasestorage.app",
  messagingSenderId: "999756577073",
  appId: "1:999756577073:web:9068bc82eb3c9af9b7d810",
  measurementId: "G-7E4M3MX095"
}
const REACT_APP_RECAPTCHA_SITE_KEY = "6LdX3S0mAAAAAGG6Ykz9O6H2f0U8b1xX6b0n0Y5D"
export { firebaseConfig, REACT_APP_RECAPTCHA_SITE_KEY }
